module.exports = __webpack_public_path__ + "img/Monte_Kope_82.6f72b1ba.jpg";